import * as React from 'react';
import {
  makeStyles,
} from '@material-ui/core';
import { OverviewList } from './components/OverviewList.component';
import {
  TimeOption, Contact, Settings, AppointmentType
} from './np-types';
import { getPhoneMask } from '../services/phone';

const useStyles = makeStyles(() => ({
  root: {
    maxWidth: '1000px',
    width: '100%',
    paddingLeft: '24px',
    paddingRight: '24px',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  overviewContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: '10px',
    marginBottom: '10px',
    justifyContent: 'center',
  },
  dateTimeContainer: {
    marginLeft: '20px',
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },
  showMobile: {
    display: 'none'
  },
  hideMobile: {
    display: 'flex',
    justifyContent: 'center',
  },
  '@media screen and (max-width: 700px)': {
    overviewContainer: {
      flexDirection: 'column',
      alignItems: 'center',
    },
    dateTimeContainer: {
      marginLeft: 0
    },
    showMobile: {
      display: 'block'
    },
    hideMobile: {
      display: 'none'
    }
  },
}));

interface ConfirmationPageProps {
  date: Date;
  time: TimeOption;
  contact: Contact;
  settings: Settings;
  selectedApptType: AppointmentType;
}

interface InsertPlaceholders {
  contact: Contact,
  confirmationDescription: string,
  officeNumber: string,
}

const insertPlaceholders = ({
  contact, confirmationDescription = '', officeNumber = ''
}: InsertPlaceholders) => {
  if (!confirmationDescription) {
    return '';
  }
  return confirmationDescription
    .replace(/{firstName}/g, contact.firstName)
    .replace(/{lastName}/g, contact.lastName)
    .replace(/{phone}/g, contact.phone)
    .replace(/{email}/g, contact.email)
    .replace(/{office.phone}/g, getPhoneMask(officeNumber));
};

export const ConfirmationPage = ({
  date, time, contact, settings,
}: ConfirmationPageProps) => {
  const classes = useStyles();

  const confirmText = React.useMemo(() => {
    return insertPlaceholders({
      contact,
      confirmationDescription: settings.confirmationDescription,
      officeNumber: settings.phone
    });
  }, [contact, settings.confirmationDescription, settings.phone]);

  return (
    <div className={classes.overviewContainer}>
      <div style={{
        marginRight: '20px', display: 'flex', flexDirection: 'column'
      }}>
        {settings.logoUrl &&
          <img
            src={settings.logoUrl}
            alt={settings.name}
            style={{ width: '100%', maxWidth: '300px', height: 'auto' }}
          />}
        <div dangerouslySetInnerHTML={{ __html: confirmText }}></div>

        <div style={{ flexGrow: 1 }}> </div>

        <div className={classes.hideMobile}>
          <OverviewList
            date={date}
            time={time}
            timezone={settings.timezone}
          />
        </div>
      </div>
    </div>
  );
};
